import React, {useEffect, useState} from "react";
import AutoFormCard from "../../../components/common/AutoFormCard";
import {useNavigate, useSearchParams} from "react-router-dom";
import {ApiService} from "../../../services/ApiService";
import {message} from "antd";
import {FormUtils} from "../../../utils/FormUtils";
import {ValueUtils} from "../../../utils/ValueUtils";
import {Constants} from "../../../utils/ConstantsUtils";

const FORM = [

    {
        name: "性别",
        key: "gender",
        type: "select",
        required: true,
    },
    {
        name: "生日",
        key: "birthday",
        type: "date",
        required: true,
    },
    {
        name: "社会阶层",
        key: "socialClass",
        type: "input",
        required: true,
    },
    {
        name: "工作领域（专业职称）",
        key: "professionalTitles",
        type: "text",
        maxLength: 200,
        required: true,
    },
    {
        name: "最高学历",
        key: "educationBackgroundId",
        type: "select",
        required: true,
    },
    {
        type: "div"
    },
    {
        name: "姓名",
        key: "name",
        type: "input",
    },
    {
        name: "身份证号",
        key: "idNumber",
        type: "input",
    },
    {
        name: "民族",
        key: "nationId",
        type: "select",
    },
    {
        name: "工作地点",
        key: "workUnit",
        type: "text",
        maxLength: 100,
    },
    {
        name: "参加工作年份",
        key: "workStartYear",
        type: "number",
    },

    {
        name: "毕业院校",
        key: "school",
        type: "input",
    },
    {
        name: "专业技能",
        key: "major",
        type: "input",
    },

    {
        name: "籍贯",
        key: "nativePlace",
        type: "text",
        maxLength: 100
    },

]

const NewStratumPersonnelEditPage = () => {
    const [searchParams] = useSearchParams()
    const navigator = useNavigate()

    const guid = searchParams.get("guid")

    const [initFormData, setInitFormData] = useState({})
    const [nations, setNations] = useState([])
    const [educationBackgrounds, setEducationBackgrounds] = useState([])

    let changedForms = {}

    useEffect(() => {
        if (guid) {
            ApiService.admin.newStratum.member.get(guid)
                .onSuccess(data => {
                    setInitFormData({
                        ...data,
                        birthday: ValueUtils.getMomentOrNull(data.birthday),
                    })
                })
        }

        ApiService.constants.nation()
            .onSuccess(setNations)
        ApiService.constants.educationBackgrounds()
            .onSuccess(setEducationBackgrounds)
    }, [guid]);

    const handleFormChange = (change) => {
        changedForms = {
            ...changedForms,
            ...change
        }
    }

    const createOrUpdate = (form) => {
        if (guid) {
            return ApiService.admin.newStratum.member.update(form)
        } else {
            return ApiService.admin.newStratum.member.create(form)
        }
    }

    const handleFormSubmit = (event) => {
        try {
            const form = FormUtils.setupSubmitForm(changedForms, {}, true, false, {guid: guid})
            createOrUpdate(form)
                .onSuccess(() => {
                    message.success("数据已保存")
                    navigator(-1)
                })
        } catch (e) {
            message.error(e.message)
            return false
        }
    }

    return (
        <>
            <AutoFormCard
                title={"新社会阶层人员信息编辑"}
                formStruct={FORM}
                initValues={initFormData}
                selectOptions={{
                    gender: Constants.genders,
                    educationBackgroundId: educationBackgrounds,
                    nationId: nations
                }}
                loading={false}
                onClickCancel={e => {
                    navigator(-1)
                }}
                onClickSubmit={handleFormSubmit}
                onFormChange={handleFormChange}
            />
        </>
    )
}

export default NewStratumPersonnelEditPage